<template>
    <div class="rp-messenger-document-item">
        <div class="rp-document-item__body">
            <div class="rp-document-item__header">
                <div v-if="status === 'success'" class="rp-document-item__success rp-document-item__header-item">
                    <i class="el-icon-success" />
                </div>
                <div class="rp-document-item__title rp-document-item__header-item">
                   <AttachmentItemVue
                        class="rp-text-overflow-elipses"
                        v-if="status === 'success' || status === 'uploaded'"
                        :percentage="percentage"
                        :uploadStatus="status"
                        :addDesign="false"
                        :attachment="file.url"
                    />
                    <div class="uploading-file-name" v-else>
                        <p :title="name" class="attachment-file-name-body">
                            <span class="attachment-file-name">
                                {{ name }}
                            </span>
                        </p>
                        <p class="attachment-file-name-percent">
                            <span class="attachment-file-percentage">
                                    ({{ percentage }}%)
                            </span> 
                        </p>
                    </div>
                </div>
                <!-- <div v-if="status!=='uploaded'" class="rp-document-item__status" :style="{ color: getColorByStatus}">
                    {{uploadStatus}}
                    <i 
                        v-if="status==='fail'"
                        class="el-icon-refresh-left"
                        @click="retryFailedFile"
                        ></i>
                </div> -->
                <div v-if="status === 'success'" class="rp-document-item__close-btn" @click="removeFile">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="rp-document-item__progress" v-if="status!=='success'">
                <el-progress :stroke-width="4" :show-text="false" :percentage="percentage" :color="getColorByStatus"></el-progress>
            </div>
        </div>
    </div>
</template>
<script>
import AttachmentItemVue from './AttachmentItem.vue';

export default {
    components: {
       AttachmentItemVue
    },

    props: {
        file: Object
    },

    computed: {
        uploadStatus() {
            if(this.status === 'uploading') 
                return this.getSize(this.file.size * (this.file.percentage/100)) + '/' + this.totalSize;
            if(this.status === 'fail')
                return 'Error uploading'
            if(this.status === 'success') 
                return 'Complete!'
        },

        status() {
            return this.file.status || 'uploaded'
        },

        totalSize() {
            return this.getSize(this.file.size);
        },

        percentage() {
            if(this.status === 'ready') {
                return 0;
            }
            if(this.status === 'uploaded') {
                return 100;
            }
            return Math.round(this.file.percentage)
        },

        name() {
            return this.file.name || 'Plastic-Cards New.jpg';
        },
        
        thumbnail() {
            return this.file.url
        },
        
        isUploadCompleted() {
            return this.file.percentage === 100;
        },

        getColorByStatus() {
            if(this.status === 'uploading' || this.status === 'ready') return '#5fc960';
            if(this.status === 'success') return '#5fc960';
            if(this.status === 'fail') return '#c2706b';
        }
    },

    methods: {

        getSize(size) {
            if( !size) return ''
            let sizes = [' B', ' KB', ' MB', ' GB',  
                         ' TB', ' PB', ' EB', ' ZB', ' YB']; 
            
            for (let i = 1; i < sizes.length; i++) { 
                if (size < Math.pow(1024, i))  
                  return (Math.round((size / Math.pow( 
                    1024, i - 1)) * 100) / 100) + sizes[i - 1]; 
            } 
            return size; 
        },
        removeFile() {
            this.$emit('removeFile', this.file)
        },

        retryFailedFile() {
            this.$emit('retryFailedFile', this.file)
        },

        errorHandler() {
            return true;
        },
    }
}
</script>
<style lang="scss" scoped>
.rp-messenger-document-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;

    .rp-document-item__body {
        min-width: 100%;
        .rp-document-item__header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            align-content: center;

            .rp-document-item__header-item {
                margin-right: 10px;
            }
            .rp-document-item__success {
                font-size: 20px;
                color: #5fc960;
            }
            .rp-document-item__title {
                max-width: 100%;
                color: #666666;
                font-size: 14px;
                font-weight: 400;
                @include textOverFlowElipses();
                cursor: pointer;
            }
            .rp-document-item__status {
                width: 40%;
                font-size: 14px;
                text-align: right;
                font-weight: 400;
                &.progress {
                    color: #cccccc;
                }
                i{
                    font-weight: bold;
                    color: #666666;
                    cursor: pointer;
                }
            }
            .rp-document-item__close-btn {
                width: 5%;
                text-align: right;
                cursor: pointer;
                margin-left: 2px;
                
                i {
                    font-weight: bold;
                    color: #333333;
                }
            }
        }
        .rp-document-item__progress {
            margin-top:  0.5rem;
        }

        .el-progress-bar__outer {
            height: 4px;
        }
    }

    .uploading-file-name {
        display: flex;

        .attachment-file-name-body {
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
        }
        .attachment-file-name-percent {
            margin: 0;
        }
    }
}
</style>